import { RoleEnum } from "@/types/auth/roleEnum.ts";
import { Level } from "@/routes/courses/enums/level.ts";
import { PaymentTypeEnum } from "@/types/enums/paymentTypeEnum";
import { OrderStatusEnum } from "@/types/enums/orderStatusEnum";
import i18n from "@/i18n/config";

export class ConstantHelper {
    static getRoleText(role: RoleEnum) {
        switch (role) {
            case RoleEnum.Admin:
                return i18n.t("common.role.admin");
            case RoleEnum.Lecturer:
                return i18n.t("common.role.lecturer");
            case RoleEnum.Student:
                return i18n.t("common.role.student");
            case RoleEnum.Parent:
                return i18n.t("common.role.parent");
            default:
                return i18n.t("common.role.unknown");
        }
    }

    static getLevelText(level: Level) {
        switch (level) {
            case Level.Beginner:
                return i18n.t("common.level.beginner");
            case Level.Intermediate:
                return i18n.t("common.level.intermediate");
            case Level.Advanced:
                return i18n.t("common.level.advanced");
            default:
                return i18n.t("common.level.unknown");
        }
    }

    static getLevelColor(level: Level) {
        switch (level) {
            case Level.Beginner:
                return "bg-green-100 text-green-800 hover:bg-green-100";
            case Level.Intermediate:
                return "bg-yellow-100 text-yellow-800 hover:bg-yellow-100";
            case Level.Advanced:
                return "bg-red-100 text-red-800 hover:bg-red-100";
            default:
                return "bg-gray-100 text-gray-800 hover:bg-gray-100";
        }
    }

    static getPaymentTypeText(paymentType: PaymentTypeEnum) {
        switch (paymentType) {
            case PaymentTypeEnum.CreditCard:
                return i18n.t("common.paymentType.creditCard");
            case PaymentTypeEnum.PayPal:
                return i18n.t("common.paymentType.payPal");
            case PaymentTypeEnum.BankTransfer:
                return i18n.t("common.paymentType.bankTransfer");
            case PaymentTypeEnum.Free:
                return i18n.t("common.paymentType.free");
            default:
                return i18n.t("common.paymentType.unknown");
        }
    }

    static getOrderStatusText(orderStatusEnum: OrderStatusEnum) {
        switch (orderStatusEnum) {
            case OrderStatusEnum.Pending:
                return i18n.t("common.orderStatus.pending");
            case OrderStatusEnum.Completed:
                return i18n.t("common.orderStatus.completed");
            case OrderStatusEnum.Cancelled:
                return i18n.t("common.orderStatus.cancelled");
            case OrderStatusEnum.PaymentPending:
                return i18n.t("common.orderStatus.paymentPending");
            case OrderStatusEnum.PaymentFailed:
                return i18n.t("common.orderStatus.paymentFailed");
            default:
                return i18n.t("common.orderStatus.unknown");
        }
    }

    static getOrderStatusColor(orderStatus: OrderStatusEnum) {
        switch (orderStatus) {
            case OrderStatusEnum.Completed:
                return "bg-green-100 text-green-800 hover:bg-green-100 dark:bg-green-900/20 dark:text-green-300";
            case OrderStatusEnum.Pending:
                return "bg-yellow-100 text-yellow-800 hover:bg-yellow-100 dark:bg-yellow-900/20 dark:text-yellow-300";
            case OrderStatusEnum.PaymentPending:
                return "bg-amber-100 text-amber-800 hover:bg-amber-100 dark:bg-amber-900/20 dark:text-amber-300";
            case OrderStatusEnum.PaymentFailed:
                return "bg-red-100 text-red-800 hover:bg-red-100 dark:bg-red-900/20 dark:text-red-300";
            case OrderStatusEnum.Cancelled:
            default:
                return "bg-gray-100 text-gray-800 hover:bg-gray-100 dark:bg-gray-800 dark:text-gray-300";
        }
    }
}
